import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../../i18n/useLanguage";
import { useDealerPricingNotes } from "../../../../stores/hooks/useDealerPricingNotes";
import { OrderItemWheel } from "../../../../stores/slices/cartSlice";
import { KeyValue } from "../../../../ui/KeyValue/KeyValue";
import { CartPrintPrice } from "../CartPrintPrice";
import { LineItems } from "./LineItems/LineItems";

type OrderItemProps = {
  orderItem: OrderItemWheel;
};

export const CartPrintItemWheel: FunctionComponent<OrderItemProps> = ({
  orderItem,
}) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  const packageNotes = useDealerPricingNotes(orderItem.itemType);

  return (
    <div className="border border-edge p-4 rounded-section grid grid-cols-9 gap-x-2 items-center">
      <div className="row-span-2 h-full">
        <img
          className={clsx(
            "w-full bg-input rounded-tw-lg object-cover object-center",
            "text-transparent aspect-square"
          )}
          alt="Product Image"
          src={orderItem.itemImageLink}
        />
      </div>
      <h3 className="text-lg font-medium col-span-8">
        {orderItem.itemTitle[language] || orderItem.itemTitle["en"]}
      </h3>
      <div className="col-span-4">
        <KeyValue>
          <>{t("searchResults.partNumber")}:</>
          <>{orderItem.itemPart.partDetails.primaryPart.wheelPartNumber}</>
        </KeyValue>
        <KeyValue>
          <>{t("searchResults.diameter")}:</>
          <>{orderItem.itemPart.partDetails.primaryPart.wheelDiameter}</>
        </KeyValue>
        {packageNotes && <div className="pb-1">&nbsp;</div>}
      </div>
      <CartPrintPrice orderItem={orderItem} />
      <LineItems orderItem={orderItem} />
    </div>
  );
};
